import { isEmpty } from "@utils/var.check";
import { INTEGRATOR_APP_FEATURE_CATEGORY } from "@modules/app/service/app.constant";

export default {
  computed: {
    isFromAuthoringCopilot() {
      const acpAppCategory = [
        INTEGRATOR_APP_FEATURE_CATEGORY.ACP_MODULE,
        INTEGRATOR_APP_FEATURE_CATEGORY.ACP_ACTIVITY,
        INTEGRATOR_APP_FEATURE_CATEGORY.ACP_COMPONENT,
      ];
      return !isEmpty(this.params.appCategory) && acpAppCategory.includes(this.params.appCategory);
    },
    isFromLessonModuleAuthoringCopilot() {
      return (
        this.isFromAuthoringCopilot &&
        INTEGRATOR_APP_FEATURE_CATEGORY.ACP_MODULE === this.params.appCategory
      );
    },
    isFromLessonActivityAuthoringCopilot() {
      return (
        this.isFromAuthoringCopilot &&
        INTEGRATOR_APP_FEATURE_CATEGORY.ACP_ACTIVITY === this.params.appCategory
      );
    },
    isFromLessonComponentAuthoringCopilot() {
      return (
        this.isFromAuthoringCopilot &&
        INTEGRATOR_APP_FEATURE_CATEGORY.ACP_COMPONENT === this.params.appCategory
      );
    },
    isFromAuthoringCopilotViewDetails() {
      return this.isFromAuthoringCopilot && !isEmpty(this.params.templateSelected);
    },
  },
};
